export const encodeURIComponent = (value) => globalThis.encodeURIComponent(value);
